"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

require("./index.css"); // eslint-disable-next-line import/no-extraneous-dependencies


require("bootstrap/dist/css/bootstrap.min.css");

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

var index_1 = require("../../index");

var ContextMenu = function (_a) {
  var dataTestId = _a.dataTestId,
      className = _a.className,
      children = _a.children,
      props = __rest(_a, ["dataTestId", "className", "children"]);

  return (0, jsx_runtime_1.jsx)("div", __assign({
    "data-testid": dataTestId,
    className: (0, classnames_1.default)('context-menu', className)
  }, props, {
    children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.OverlayTrigger, __assign({
      trigger: "click",
      placement: "left",
      overlay: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Popover, __assign({
        id: "popover-basic",
        "data-testid": "popover-basic",
        className: "popup-menu"
      }, {
        children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Popover.Content, {
          children: children
        }, void 0)
      }), void 0)
    }, {
      children: (0, jsx_runtime_1.jsx)(index_1.Button, __assign({}, props, {
        className: "action-button",
        "aria-label": "Action Button",
        variant: "success"
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "more-vert",
          width: "24",
          className: "fill icon-orange"
        }, void 0)
      }), void 0)
    }), void 0)
  }), void 0);
};

exports.default = ContextMenu;